package ai.flowstorm.studio.resources

import ai.flowstorm.common.resources.EntityResource
import ai.flowstorm.studio.common.state.AppState
import ai.flowstorm.studio.model.GeneratedSample
import io.kvision.rest.HttpMethod

object GeneratedSampleResource: EntityResource<GeneratedSample>(serializer = GeneratedSample.serializer()) {
    suspend fun resubmit(entity: GeneratedSample): GeneratedSample {
        val payload = entity.copy(output = null)
        console.log(payload)
        return remoteCall(
            "/resubmit",
            payload,
            HttpMethod.POST,
            GeneratedSample.serializer(),
            doToast = false
        )
    }

    override val resourceUri: String
        get() = "/spaces/${AppState.state.spaceId!!.value}/generatedSamples"
}